import shopifyGenericDefaults from '../shopify-generic/config.js';
import {
  initDeliveryEstimate,
  refreshDeliveryEstimates,
  serializeDeliveryInventory,
} from './deliveryEstimate.js';
import { regoSearch } from './helpers.js';

const baseFitmentFields = shopifyGenericDefaults.fitmentSearch.baseFields;
const extraFitmentFields = shopifyGenericDefaults.fitmentSearch.extraFields;

const inheritedSearchResult = shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'SearchResult');

window.Convermax.serializeDeliveryInventory = serializeDeliveryInventory;

window.Convermax.regoSearch = (event) =>
  regoSearch(event, [...baseFitmentFields, ...extraFitmentFields], baseFitmentFields);

window.Convermax.openPostcodeModal = () => {
  if (typeof window.openPostcodeModal === 'function') {
    window.openPostcodeModal();
  } else {
    window.document.getElementById('postcode-modal-trigger')?.click();
  }
};

window.Convermax.switchTabInSearchByVehicleDialog = (event, targetIndex) => {
  const dialog = event.target?.closest('.vehicle-search-modal__dialog');
  if (!dialog) {
    return;
  }

  const panels = dialog.querySelectorAll('.vehicle-search-modal__panel');
  const activeIndex = [...panels].findIndex((p) =>
    p.classList.contains('vehicle-search-modal__panel--active'),
  );
  const destination = targetIndex !== undefined ? targetIndex : activeIndex === 0 ? 1 : 0;

  panels.forEach((panel, i) => {
    const isTarget = i === destination;
    panel.classList.toggle('vehicle-search-modal__panel--active', isTarget);
    panel.hidden = !isTarget;
  });

  const titles = ['Rego Search', 'Manual Vehicle Search', 'My Garage'];
  const title = dialog.querySelector('.vehicle-search-modal__title');
  if (title) {
    title.textContent = titles[destination];
  }
};

window.Convermax.openGarageInDialog = (event) => {
  const dialog = event.target?.closest('.vehicle-search-modal__dialog');
  if (!dialog) {
    return;
  }

  const panels = dialog.querySelectorAll('.vehicle-search-modal__panel');
  panels.forEach((panel, i) => {
    const isTarget = i === 2;
    panel.classList.toggle('vehicle-search-modal__panel--active', isTarget);
    panel.hidden = !isTarget;
  });

  const title = dialog.querySelector('.vehicle-search-modal__title');
  if (title) {
    title.textContent = 'My Garage';
  }
};

function InitFunc() {
  shopifyGenericDefaults.InitFunc?.();
  initDeliveryEstimate();

  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers, #cm-collection-page')) {
    const unwantedPageWrappers = [['#MainContent .section.page-width-content', 'page-width-content']];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);
    });
  }
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (widget) =>
        !['HomeVehicleWidget_tab', 'SearchResult', 'SearchVehicleWidget', 'VehicleWidgetDialog'].includes(
          widget.name,
        ),
    ),
    {
      ...inheritedSearchResult,
      updateCallback: (...args) => {
        inheritedSearchResult.updateCallback?.(...args);
        refreshDeliveryEstimates();
      },
    },
    {
      name: 'RegoSearchPanelTab',
      type: 'SearchPage',
      location: '#cm-rego-search-panel',
      template: 'RegoSearchPanelTab',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'HomeVehicleWidget_tab'),
      template: 'fitmentSearch/homeVehicleWidget',
      redirectUrl: '/collections/all',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'VehicleWidgetDialog'),
      location: {
        id: 'cm_SearchByVehicleDialog',
        class: 'SearchByVehicleDialog',
      },
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
    },
    {
      name: 'SearchByVehicleDialogButton',
      type: 'SingleVehicleGarage',
      location: '#cm-search-by-vehicle-dialog-button',
      template: 'SearchByVehicleDialogButton',
    },
    {
      name: 'SearchByVehicleDialogButtonMobile',
      type: 'SingleVehicleGarage',
      location: '#cm-search-by-vehicle-dialog-button-mobile',
      template: 'SearchByVehicleDialogButtonMobile',
    },
  ],
};
